import React from 'react';

import { BADGE_BASE } from './badgeBase';

// "Custom" marker used on every surface that shows a custom field (#972).
// aria-label, never a native title: #975 forbids titles on headers and badges.
export default function CustomFieldBadge({ className = '', ...rest }) {
    return (
        <span
            data-testid="custom-field-badge"
            aria-label="Custom field"
            className={`${BADGE_BASE} bg-[#EFEAFE] text-[#4D11F6] dark:bg-[#2B2158] dark:text-[#BBA9FF] ${className}`}
            {...rest}
        >
            Custom
        </span>
    );
}
